module.exports = __webpack_public_path__ + "img/album04_02.5a306e55.jpg";